import isURL from 'validator/lib/isURL';
const isHashOrUrl = value => isURL(value) || value === '#';

export default isHashOrUrl;
